/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import agClientComponents from './components';
import agAlarmsWidget from './alarm/alarms-widget.directive';

import agAssetsWidget from './asset/assets-widget.directive';
import agAssetComments from './asset/asset-comments.directive';
import agClientAssetDashboard from './asset/dashboard';
import agAssetMultiSettingsWidget from './asset/asset-multi-settings-widget.directive';

import agSystemWidget from './system/system-widget.directive';
import agSystemDetails from './system/system-details.directive';
import agSystemSettings from './system/system-settings.directive';

import agSiteWidget from './site/site-widget.directive';
import agSiteDetails from './site/site-details.directive';
import agSiteSettings from './site/site-settings.directive';
import agSite3dOverview from './site/site-3d-overview.directive';

import agSiloOverview from './silo/silo-overview.directive';
import agTelemetryOverview from './overview/telemetry-overview.directive';
import agGeneralOverview from './overview/general-overview.directive';
import agHeadSpaceOverview from './overview/headspace-overview.directive';
import agCropLevelOverview from './overview/croplevel-overview.directive';
import agFansOverview from './overview/fans-overview.directive';
import agSingleFanOverview from './overview/single-fan-overview.directive';
import agSiloWidget from './silo/silo-widget.directive';
import agSiloDetails from './silo/silo-details.directive';
import agSiloCropLevel from './silo/silo-crop-level.directive';
import agSiloHeadSpace from './silo/silo-head-space.directive';
import agSiloSensorsHistory from './silo/silo-sensors-history.directive';
import agSensorLineSettings from './silo/sensor-line-settings.directive';
import agSiloSettings from './silo/silo-settings.directive';
import agSiloConnectedSystems from './silo/silo-connected-systems.directive';

import agSiloGroupWidget from './silogroup/silo-group-widget.directive';
import agSiloGroupOverview from './silogroup/silo-group-overview.directive';
import agSiloGroupDetails from './silogroup/silo-group-details.directive';
import agSiloGroupSettings from './silogroup/silo-group-settings.directive';

import agWeatherStationWidget from './weatherstation/weather-station-widget.directive';
import agWeatherStationDetails from './weatherstation/weather-station-details.directive';
import agWeatherStationSettings from './weatherstation/weather-station-settings.directive';

import agAerationWidget from './aeration/aeration-widget.directive';
import agAerationDetails from './aeration/aeration-details.directive';
import agAerationSettings from './aeration/aeration-settings.directive';
import agAerationConnectedSystems from './aeration/aeration-connected-systems.directive';

export default angular.module('agrolog.client', [
    agClientComponents,
    agAlarmsWidget,
    agAssetsWidget,
    agAssetComments,
    agClientAssetDashboard,
    agAssetMultiSettingsWidget,
    agSystemWidget,
    agSystemDetails,
    agSystemSettings,
    agSiteWidget,
    agSiteDetails,
    agSiteSettings,
    agSiloOverview,
    agTelemetryOverview,
    agSite3dOverview,
    agGeneralOverview,
    agHeadSpaceOverview,
    agCropLevelOverview,
    agFansOverview,
    agSingleFanOverview,
    agSiloWidget,
    agSiloDetails,
    agSiloCropLevel,
    agSiloHeadSpace,
    agSiloSensorsHistory,
    agSensorLineSettings,
    agSiloSettings,
    agSiloConnectedSystems,
    agSiloGroupWidget,
    agSiloGroupOverview,
    agSiloGroupDetails,
    agSiloGroupSettings,
    agWeatherStationWidget,
    agWeatherStationDetails,
    agWeatherStationSettings,
    agAerationWidget,
    agAerationDetails,
    agAerationSettings,
    agAerationConnectedSystems])
    .name;
